<div class="container" tid="home-page" id="home-container" tamDropzone>
    <tam-toast></tam-toast>
    <div class="sidebar">
        <navigation-menu [config]="navigationMenuConfig" class="navigation-menu"></navigation-menu>
    </div>
    <div class="top-chrome" #topbar>
        <div class="search-area">
            <tam-simple-search [config]="simpleSearchConfig">
            </tam-simple-search>
        </div>
        <div class="right-area">
            <div class="right-corner">
                <div class="action-ele-tasks">
                    <smart-icon name="tasks" class="task-list" tid="task-list-icon" (click)="onShowTaskList($event)">
                    </smart-icon>
                </div>
            </div>
            <div class="right-corner">
                <div class="action-ele" #anchor>
                    <smart-icon name="question-circle" class="dropdown-smart-icon" tid="help_info"
                        (click)="goToHelpPage()"></smart-icon>
                </div>
                <kendo-popup [anchor]="anchor" [margin]="{vertical:8,horizontal:-216}" class="message-transparent"
                    *ngIf="messages&&messages.length">
                    <div class="message-container message-transparent">
                        <div class="one-message" *ngFor="let item of messages;index as i"
                            (click)="onMessageClick($event,item,i)" (mouseenter)="onMessageMouseEnter($event,item,i)"
                            (mouseleave)="onMessageMouseLeave($event,item,i)">
                            <div class="message-meta-container">
                                <div class="message-meta-left">
                                    <div class="message-meta-icon">
                                        <smart-icon [name]="item.icon"></smart-icon>
                                    </div>
                                    <div class="message-meta-info body-1">
                                        {{item.header}}
                                    </div>
                                </div>
                                <div class="message-meta-right caption-2 no-wrap">
                                    {{item.date|date:'dd MMM yyyy HH:mm'}}
                                </div>
                                <div class="message-meta-right">
                                    <smart-icon name="close" (click)="onMessageClose($event, item, i)"></smart-icon>
                                </div>
                            </div>
                            <div class="message-title-container body-2" [title]="item.title">
                                {{item.title}}
                            </div>
                            <div class="message-subtitle-container body-3" *ngIf="item.subtitle"
                                [title]="item.subtitle">
                                {{item.subtitle}}
                            </div>
                        </div>
                    </div>
                </kendo-popup>
            </div>
            <div class="right-corner">
                <div (click)="showUserContextMenu($event)" class="action-ele">
                    <smart-icon name="user-circle" class="dropdown-smart-icon" tid="current_user"></smart-icon>
                </div>
                <tam-context-menu [config]="userMenuConfig"></tam-context-menu>
            </div>
        </div>
    </div>
    <div class="sub-chrome">
        <sub-chrome></sub-chrome>
    </div>
    <div class="content-container" [style.top]="contentContainerTop">
        <div tid="float-menu" [hidden]="!showFloatMenu">
            <float-menu-draft-count [hidden]="!onlyShowFloatMenu">
            </float-menu-draft-count>
            <float-menu-draft-panel [hidden]="onlyShowFloatMenu"></float-menu-draft-panel>
        </div>
        <router-outlet></router-outlet>
    </div>
    <div class="right-float-container-thread-sidesheet" [ngClass]="{'show': showThreadDetailSideSheet}">
        <thread-side-sheet [config]="threadSideSheetConfig"></thread-side-sheet>
    </div>
    <tam-autotag-model-dialog></tam-autotag-model-dialog>
    <tam-web-sites-dialog></tam-web-sites-dialog>
    <note-dialog></note-dialog>
    <tam-add-relationship-entity-dialog></tam-add-relationship-entity-dialog>
    <entity-dialog [id]="instanceId"></entity-dialog>
    <calendar-dialog></calendar-dialog>
    <!-- <tam-map-tile-dialog></tam-map-tile-dialog> -->
    <!--Keep it after new contact no bugs-->
    <!-- <contact-dialog-crm [id]="instanceId"></contact-dialog-crm> -->
    <contact-dialog [id]="instanceId"></contact-dialog>
    <tam-template-setting-dialog></tam-template-setting-dialog>
    <new-relationship-dialog></new-relationship-dialog>
    <save-screen-dialog></save-screen-dialog>
    <intralinks-account-dialog></intralinks-account-dialog>
    <intralinks-mapping-dialog></intralinks-mapping-dialog>
    <tam-audit-trail></tam-audit-trail>
    <tam-slide-sheet></tam-slide-sheet>
    <tam-bottom-slide-sheet></tam-bottom-slide-sheet>
    <tam-dashboard-dialog></tam-dashboard-dialog>
    <tam-workflow-dialog></tam-workflow-dialog>
    <email-digest-dialog></email-digest-dialog>
    <tam-confirm-send-dialog></tam-confirm-send-dialog>
    <tam-manage-relationship-dialog></tam-manage-relationship-dialog>
    <email-digest-preview-box></email-digest-preview-box>
    <tam-note-attachments-buffer [disableBuffer]="disableBuffer"></tam-note-attachments-buffer>
    <tam-pdffile-preview [config]='filePreviewConfig'></tam-pdffile-preview>
    <ng-template #flyContainer></ng-template>
    <tam-print-dialog></tam-print-dialog>
    <tam-remove-relationship-dialog></tam-remove-relationship-dialog>
    <tam-duplicated-contact-dialog></tam-duplicated-contact-dialog>
    <tam-append-entities-dialog></tam-append-entities-dialog>
    <tam-append-entity-confirm-dialog></tam-append-entity-confirm-dialog>
    <user-password-dialog></user-password-dialog>
    <tam-select-window></tam-select-window>
    <app-alert-window></app-alert-window>
    <tam-img-preview></tam-img-preview>
    <thread-filter-dialog></thread-filter-dialog>
    <div class="copy-area"><textarea #copyArea></textarea></div>
    <!--https://angular-maps.com/guides/getting-started/-->
    <!--https://stackoverflow.com/questions/47562107/angular-5-google-is-not-defined-google-maps-->
    <!--Due to use AGM (angular google map) api must load agm-map control-->
    <agm-map [latitude]="lat" [longitude]="lng">
        <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
    </agm-map>
</div>
<tam-print-preview-dashboard></tam-print-preview-dashboard>